module.exports = "/_next/static/images/AIAndML-xs-4975be4450fc29a025949182b7572b06.png";